var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8336 4.5H17.8229V9.89648C17.8229 11.4072 17.652 12.6069 17.3102 13.4956C16.9684 14.3843 16.3497 15.1089 15.4542 15.6694C14.5656 16.2231 13.3966 16.5 11.9474 16.5C10.5392 16.5 9.38733 16.2573 8.49182 15.772C7.59631 15.2866 6.95715 14.5859 6.57434 13.6699C6.19153 12.7471 6.00012 11.4893 6.00012 9.89648L6.00012 4.5H7.98938V9.88623C7.98938 11.1919 8.10901 12.1558 8.34827 12.7778C8.59436 13.3931 9.01135 13.8682 9.59924 14.2031C10.194 14.5381 10.9186 14.7056 11.7731 14.7056C13.236 14.7056 14.2784 14.374 14.9005 13.7109C15.5226 13.0479 15.8336 11.7729 15.8336 9.88623V4.5Z",
    fill: "#6B7280"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.00012,
    y: 18.5,
    width: 12,
    height: 1,
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineIcon);
export default __webpack_public_path__ + "static/media/underlineIcon.9323ee270d28745b3e375202ccf39438.svg";
export { ForwardRef as ReactComponent };